/**
 * @description LYN-394: only the latest in-flight load may write
 *
 * @dependencies none
 * @notes begin() returns isCurrent(). A later begin() or invalidate()
 *   makes a prior generation stale. Stale catalog/flag results no-op.
 */

function createLatestLoadGate(initial) {
  let current = initial || 0;
  return {
    begin() {
      current += 1;
      const gen = current;
      return () => gen === current;
    },
    invalidate() {
      current += 1;
    }
  };
}

module.exports = { createLatestLoadGate };
